/**
 * @generated SignedSource<<7bc9c1a8fee0aeb329a9668830ec200b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateGitLabInstallationLinkInput = {
  baseUrl: string;
  cidrRanges?: ReadonlyArray<string> | null | undefined;
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  oauthScopes?: ReadonlyArray<string> | null | undefined;
  source?: string | null | undefined;
  syncedResources?: ReadonlyArray<string> | null | undefined;
};
export type GitLabIntegrationCreateInstallationLinkMutation$variables = {
  input: CreateGitLabInstallationLinkInput;
};
export type GitLabIntegrationCreateInstallationLinkMutation$data = {
  readonly createGitlabInstallationLink: {
    readonly installationLink: string;
  };
};
export type GitLabIntegrationCreateInstallationLinkMutation = {
  response: GitLabIntegrationCreateInstallationLinkMutation$data;
  variables: GitLabIntegrationCreateInstallationLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGitLabInstallationLinkPayload",
    "kind": "LinkedField",
    "name": "createGitlabInstallationLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installationLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GitLabIntegrationCreateInstallationLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GitLabIntegrationCreateInstallationLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf1cc6e81bfdc50e450e061f3434526a",
    "id": null,
    "metadata": {},
    "name": "GitLabIntegrationCreateInstallationLinkMutation",
    "operationKind": "mutation",
    "text": "mutation GitLabIntegrationCreateInstallationLinkMutation(\n  $input: CreateGitLabInstallationLinkInput!\n) {\n  createGitlabInstallationLink(input: $input) {\n    installationLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "86217bf4ac7956987a8b7e6b5880d528";

export default node;
